import {id} from "date-fns/locale";
import {key} from "localforage";
import Facility from "./Facility";

export default class Comment {

    constructor(id:number, key:string, content:string) {
        this._id = id;
        this._key = key;
        this._content = content;
    }

    static fromResponse(data) {
        const comment = new Comment(data.id, data['key'], data['content']);
        return comment;
    }

    toJSON() : Object {
        return {
            id: this._id,
            key: this._key,
            content: this._content
        };
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get key(): string {
        return this._key;
    }

    set key(value: string) {
        this._key = value;
    }

    get content(): string {
        return this._content;
    }

    set content(value: string) {
        this._content = value;
    }
}